import React from 'react'
import { useTranslation } from 'react-i18next'
import { Block } from '@comp/crRender'
import SectionCard from '../../shared/SectionCard'
import './style.css'

const VideoSection = ({ videoUrl }) => {
    const { t } = useTranslation()

    return (
        <Block isRender={videoUrl} className="video-section">
            <SectionCard icon="mdi:video" titleKey="video">
                <div className="video-container">
                    <iframe
                        className="video-iframe"
                        src={videoUrl}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="Hospital Video"
                    />
                </div>
            </SectionCard>
        </Block>
    )
}

export default VideoSection

